interface FolderPlusIconProps {
  size?: number;
}

const FolderPlusIcon: React.FC<FolderPlusIconProps> = ({ size = 16 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      <path
        d="M1.5 3.5 L1.5 12.5 C1.5 13 1.8 13.5 2.5 13.5 L13.5 13.5 C14.2 13.5 14.5 13 14.5 12.5 L14.5 5.5 C14.5 5 14.2 4.5 13.5 4.5 L7.5 4.5 L6 2.5 L2.5 2.5 C1.8 2.5 1.5 3 1.5 3.5 Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M8 7.2 L8 10.8 M6.2 9 L9.8 9"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default FolderPlusIcon;
